"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditSeverityEnum = void 0;
var AuditSeverityEnum;
(function (AuditSeverityEnum) {
    AuditSeverityEnum["Low"] = "L";
    AuditSeverityEnum["Medium"] = "M";
    AuditSeverityEnum["High"] = "H";
})(AuditSeverityEnum = exports.AuditSeverityEnum || (exports.AuditSeverityEnum = {}));
